export function shouldReloadNavigation({
  source,
  currentRouteName,
  targetRouteName,
} = {}) {
  return source === 'menu-click' &&
    Boolean(currentRouteName) &&
    currentRouteName === targetRouteName
}
